import { STEP } from "#src/constants/step.ts";
import { defineStore } from "#src/stores/state-wrapper.js";
import { REQS } from "#src/constants/data-requirements.ts";

import { useStepEmployerStore } from "#src/stores/step-employer.js";
import { useStepContactStore } from "#src/stores/step-contact.js";

export const useStepAddressStore = (pinia, hot) =>
  defineStore("step-address", {
    // can move these to their respective forms and use in component savable property?
    // Unease ~ removes from API-ability?
    state: () => ({
      inactive: false,
      requiredFields: {
        address: false,
        yearsAtAddress: false,
      },
    }),
    getters: {
      step: () => STEP.ADDRESS,
      previous: () => {
        const contact = useStepContactStore(pinia);
        return contact.step;
      },
      next() {
        const employer = useStepEmployerStore(pinia);
        if (employer.inactive) return employer.next;
        return employer.step;
      },
    },
    actions: {
      setStepRequirements(srq) {
        this.requiredFields.address = srq[REQS.INSURED_ADDRESS];
        this.requiredFields.yearsAtAddress =
          srq[REQS.INSURED_ADDRESS_START_DATE];

        this.inactive = !Object.values(this.requiredFields).includes(true);
      },
    },
  })(pinia, hot);
